import { render, staticRenderFns } from "./InformationPopup.vue?vue&type=template&id=484cfee6"
import script from "./InformationPopup.vue?vue&type=script&lang=js"
export * from "./InformationPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports